/* eslint-disable no-restricted-syntax */
import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'

const PAGESIZE = 20

export const get_ra_trade_detail = createAsyncThunk(
  //  1 售卖记录 http://wiki.xunlei.cn/pages/viewpage.action?pageId=90610008
  'CoinAgencyWallet/get_ra_trade_detail',
  async (params: any, store: any) => {
    const resp = await http.post(
      '/live/pay/get_ra_trade_detail',
      {
        ...params,
      },
      {
        store,
        xcErrorToast: true,
      }
    )
    return {data: resp.data.data}
  }
)

export const get_ra_recharge_detail = createAsyncThunk(
  // 2 购买详情 http://wiki.xunlei.cn/pages/viewpage.action?pageId=90610011
  'NewCoinAgencyWallet/get_ra_recharge_detail',
  async (params: any, store: any) => {
    const resp = await http.post(
      '/live/pay/get_ra_recharge_detail',
      {
        ...params,
      },
      {
        store,
        xcErrorToast: true,
      }
    )
    return {data: resp.data.data}
  }
)

export const senior_trade_his = createAsyncThunk(
  //  3  分销商调用的购买详情接口是 http://wiki.xunlei.cn/pages/viewpage.action?pageId=96305373
  'NewCoinAgencyWallet/senior_trade_his',
  async (params: any, store: any) => {
    const resp = await http.post(
      '/live/pay/senior_trade_his',
      {
        ...params,
        page: Math.floor(params?.offset / PAGESIZE + 1) || 1,
        page_size: PAGESIZE,
        kind: 3,
      },
      {
        store,
        xcErrorToast: true,
      }
    )
    return {data: resp.data.data}
  }
)

export const get_ra_obtain_detail = createAsyncThunk(
  //  4 奖励详情 http://wiki.xunlei.cn/pages/viewpage.action?pageId=167776057
  'NewCoinAgencyWallet/get_ra_obtain_detail',
  async (params: any, store: any) => {
    const resp = await http.post(
      '/live/pay/get_ra_obtain_detail',
      {
        ...params,
        limit: PAGESIZE,
      },
      {
        store,
        xcErrorToast: true,
      }
    )
    return {data: resp.data.data}
  }
)

export const super_ra_trade_his = createAsyncThunk(
  //  5 被分销详情 http://wiki.xunlei.cn/pages/viewpage.action?pageId=117021249
  'NewCoinAgencyWallet/super_ra_trade_his',
  async (params: any, store: any) => {
    const resp = await http.post(
      '/live/pay/super_ra_trade_his',
      {
        ...params,
        kind: 2,
        limit: PAGESIZE,
      },
      {
        store,
        xcErrorToast: true,
      }
    )
    return {data: resp.data.data}
  }
)

export enum KindEnum {
  账户 = 1,
  国家 = 2,
  快捷回复 = 3,
}

export enum ActionEnum {
  列表 = 0,
  添加 = 1,
  更新 = 2,
  删除 = 3,
}

export const settings = createAsyncThunk(
  'NewCoinagency/settings',
  async (p: any, store: any) => {
    const resp = await http.post('/live/merchant/settings', p, {
      store,
      xcErrorToast: true,
    })
    return resp.data.data
  }
)
export const update_settings = createAsyncThunk(
  'NewCoinagency/update_settings',
  async (p: any, store: any) => {
    // return {}
    const resp = await http.post('/live/merchant/update_settings', p, {
      store,
      xcErrorToast: true,
    })
    return resp.data.data
  }
)

export const first_recharge_gift = createAsyncThunk(
  'NewCoinagency/first_recharge_gift',
  async (p: any, store: any) => {
    // return {
    //     eligible: true,
    //     gift_status: 1, // 1（可领取）、2（已领取）、3（已失效）
    //     countdown: 10,
    //     tiers: [
    //         {
    //             min_amount: 100,
    //             rewards: [
    //                 {type: 1, picture: 'https://img01.mehiya.com/img/png/id/173698800235', min: 1000, max: 10000, amount: 1000},
    //                 {type: 2, picture: 'https://img01.mehiya.com/img/png/id/173698800235', min: 1000, max: 10000, amount: 1000},
    //                 {type: 3, picture: 'https://img01.mehiya.com/img/png/id/173698800235', min: 1000, max: 10000, amount: 1000},
    //             ]
    //         },
    //         {
    //             min_amount: 100,
    //             rewards: [
    //                 {type: 1, picture: 'https://img01.mehiya.com/img/png/id/173698800235', min: 1000, max: 10000, amount: 1000},
    //                 {type: 2, picture: 'https://img01.mehiya.com/img/png/id/173698800235', min: 1000, max: 10000, amount: 1000},
    //                 {type: 3, picture: 'https://img01.mehiya.com/img/png/id/173698800235', min: 1000, max: 10000, amount: 1000},
    //             ]
    //         },
    //         {
    //             min_amount: 100,
    //             rewards: [
    //                 {type: 1, picture: 'https://img01.mehiya.com/img/png/id/173698800235', min: 1000, max: 10000, amount: 1000},
    //                 {type: 2, picture: 'https://img01.mehiya.com/img/png/id/173698800235', min: 1000, max: 10000, amount: 1000},
    //                 {type: 3, picture: 'https://img01.mehiya.com/img/png/id/173698800235', min: 1000, max: 10000, amount: 1000},
    //             ]
    //         },
    //     ],
    // }
    const resp = await http.post('/live/merchant/first_recharge_gift', p, {
      store,
      xcErrorToast: true,
    })
    return resp.data.data
  }
)

export const summary = createAsyncThunk(
  // 币商中心--销售数据 [http://wiki.xunlei.cn/pages/viewpage.action?pageId=167776064]
  'NewCoinagency/summary',
  async (p: any, store: any) => {
    const resp = await http.post('/live/merchant/summary', p, {
      store,
      xcErrorToast: true,
    })
    return resp.data.data
  }
)

export interface InitialStateType {
  commonSettings?: any
  firstRecharge?: any
  coinDetail?: {
    loading: boolean
    get_ra_trade_detail?: any
    get_ra_recharge_detail?: any
    senior_trade_his?: any
    get_ra_obtain_detail?: any
    super_ra_trade_his?: any
  }
  summaryData?: any
}

const initialState: InitialStateType = {}

const initData: InitialStateType = {
  coinDetail: {
    loading: true,
  },
  commonSettings: {},
  firstRecharge: {},
  summaryData: {},
}

export const NewCoinagencySlice = createSlice({
  name: 'NewCoinagency',
  initialState,
  reducers: {
    initData: (state) => {
      Object.assign(state, initData)
    },
    setLoadingTrue: (state, action) => {
      // state.coinDetail.loading = action.payload
      Object.assign(state, {
        coinDetail: {
          ...state.coinDetail,
          loading: true,
        },
      })
    },
    clearCoinDetail: (state, action) => {
      Object.assign(state, {
        coinDetail: {
          loading: true,
        },
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase(get_ra_trade_detail.fulfilled, (state, action) => {
      Object.assign(state.coinDetail, {
        get_ra_trade_detail: {
          list: [
            ...(state?.coinDetail?.get_ra_trade_detail?.list || []),
            ...action.payload?.data?.list,
          ],
          more: action.payload?.data?.more,
          offset: action.payload?.data?.offset,
        },
        loading: false,
      })
    })
    builder.addCase(get_ra_recharge_detail.fulfilled, (state, action) => {
      Object.assign(state.coinDetail, {
        get_ra_recharge_detail: {
          list: [
            ...(state?.coinDetail?.get_ra_recharge_detail?.list || []),
            ...action.payload?.data?.list,
          ],
          more: action.payload.data?.more,
          offset: action.payload?.data?.offset,
        },
        loading: false,
      })
    })
    builder.addCase(senior_trade_his.fulfilled, (state, action) => {
      Object.assign(state.coinDetail, {
        senior_trade_his: {
          list: [
            ...(state?.coinDetail?.senior_trade_his?.list || []),
            ...action.payload?.data?.list,
          ],
          more: action.payload.data?.more,
          offset: action.payload?.data?.page * action.payload?.data?.page_size,
        },
        loading: false,
      })
    })
    builder.addCase(get_ra_obtain_detail.fulfilled, (state, action) => {
      Object.assign(state.coinDetail, {
        get_ra_obtain_detail: {
          list: [
            ...(state?.coinDetail?.get_ra_obtain_detail?.list || []),
            ...action.payload?.data?.list?.map((item) => {
              return {...item, remark: item?.from}
            }),
          ],
          more: action.payload.data?.more,
          offset: action.payload?.data?.offset,
        },
        loading: false,
      })
    })
    builder.addCase(super_ra_trade_his.fulfilled, (state, action) => {
      Object.assign(state.coinDetail, {
        super_ra_trade_his: {
          list: [
            ...(state?.coinDetail?.super_ra_trade_his?.list || []),
            ...action.payload?.data?.list,
          ],
          more: action.payload.data?.more,
          offset: action.payload?.data?.offset,
        },
        loading: false,
      })
    })

    builder.addCase(settings.fulfilled, (state, action) => {
      Object.assign(state.commonSettings, action.payload)
    })
    builder.addCase(first_recharge_gift.fulfilled, (state, action) => {
      Object.assign(state.firstRecharge, action.payload)
    })
    builder.addCase(summary.fulfilled, (state, action) => {
      Object.assign(state.summaryData, action.payload)
    })
  },
})
export default NewCoinagencySlice.reducer
export const NewCoinagencyActions = NewCoinagencySlice.actions

export const useNewCoinagencyState = () => {
  const data = useSelector((state) => {
    return state.Animal_Octopus
  })
  return data
}
